import React, { FC, ReactElement } from 'react';
import { compose } from 'redux';
import { withEmptyDataHandler } from 'b2b-apps/shop/common/hoc/withEmptyDataHandler';
import { withFailHandler } from 'b2b-apps/shop/common/hoc/withFailHandler';
import { withNotFoundHandler } from 'b2b-apps/shop/common/hoc/withNotFoundHandler';
import { withNotPermittedHandler } from 'b2b-apps/shop/common/hoc/withNotPermittedHandler';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';

const withAllFailHandler = <
  P extends Record<string, any>,
  R extends RemoteRecord<any> = RemoteRecord<any>,
  E extends Record<string, any> = Record<string, any>,
>(
    getRemoteRecords: (props: P) => R[],
    ErrorComponent?: FC<E & { remoteRecord: R }>,
    getErrorComponentProps: (props: P) => E = (props: P) => ({} as E),
  ) => (Component: FC<P>): FC<P> => {
    const WithAllFailHandler = (props: P): ReactElement => (
    <Component {...props} />
    );

    return compose(
      withNotFoundHandler((props: P) => getRemoteRecords(props)),
      withNotPermittedHandler((props: P) => getRemoteRecords(props)),
      withFailHandler((props: P) => getRemoteRecords(props), ErrorComponent, getErrorComponentProps),
      withEmptyDataHandler((props: P) => getRemoteRecords(props)),
    )(WithAllFailHandler);
  };

export { withAllFailHandler };
